import { render, staticRenderFns } from "./DetailForm.vue?vue&type=template&id=73b216d2&scoped=true&"
import script from "./DetailForm.vue?vue&type=script&lang=ts&"
export * from "./DetailForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b216d2",
  null
  
)

export default component.exports